import { Link } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

function TraceabilityIndex(props) {
  return (
    <div className="mt-2 lg:px-8">
      <div className="sm:flex sm:items-center px-4 py-5">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Traceability
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Select a traceability option to get started.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
        <Link
          to="/traceability/manufactured"
          className="block p-6 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 hover:border-main-purple focus:outline-none focus:ring-2 focus:ring-main-purple focus:ring-offset-2 transition-colors"
        >
          <h3 className="text-lg font-semibold text-gray-900">
            Trace Manufactured Products
          </h3>
          <p className="mt-2 text-sm text-gray-600">
            Search by shipping barcode or manufactured lot number to trace
            production, packaging, and shipping history.
          </p>
        </Link>
        <Link
          to="/traceability/supplier"
          className="block p-6 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 hover:border-main-purple focus:outline-none focus:ring-2 focus:ring-main-purple focus:ring-offset-2 transition-colors"
        >
          <h3 className="text-lg font-semibold text-gray-900">
            Trace Supplier Products
          </h3>
          <p className="mt-2 text-sm text-gray-600">
            Search by receiving lot number to trace raw materials from receipt
            through manufacturing, packaging, and shipping.
          </p>
        </Link>
        <Link
          to="/traceability/packaging-barcode"
          className="block p-6 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 hover:border-main-purple focus:outline-none focus:ring-2 focus:ring-main-purple focus:ring-offset-2 transition-colors"
        >
          <h3 className="text-lg font-semibold text-gray-900">
            Packaging Barcode Lookup
          </h3>
          <p className="mt-2 text-sm text-gray-600">
            Scan a carton or pallet barcode to view the resolved packaging item
            and full event timeline.
          </p>
        </Link>
        <Link
          to="/traceability/receiving-item"
          className="block p-6 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 hover:border-main-purple focus:outline-none focus:ring-2 focus:ring-main-purple focus:ring-offset-2 transition-colors"
        >
          <h3 className="text-lg font-semibold text-gray-900">
            Receiving Item Lookup
          </h3>
          <p className="mt-2 text-sm text-gray-600">
            Scan a receiving barcode to view resolved item details, invoice
            context, and full receiving history timeline.
          </p>
        </Link>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TraceabilityIndex),
);
